import Common from '../Common';

const Unread = class extends Common {
	read = (): CustomResponse<Unread> =>
		this.get('/unread')

	setRead = (type: string, which: string) =>
		this.post(`/unread/${type}/${which}`)
}

export default Unread;
